var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-row",class:{shrink: _vm.shrink, block: _vm.block, grow: _vm.grow, noMargin: _vm.noMargin, stretch: _vm.stretch, center: _vm.center, noWrap: _vm.noWrap, reverse: _vm.reverse}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }